<h2 mat-dialog-title>Verification Confirmation</h2>
<mat-dialog-content>
  શું તમે ખરેખર ચકાસવા માંગો છો {{ member.name }}?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" >હા</button>
  <button mat-button [mat-dialog-close]="false">ના</button>
</mat-dialog-actions>